import { render, staticRenderFns } from "./StatsSummary.vue?vue&type=template&id=242636ae"
import script from "./StatsSummary.vue?vue&type=script&lang=js"
export * from "./StatsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports